import { useQuery } from '@apollo/client';
import { hasCptDataQuery } from '@/graph/dashboard';
import { useScope } from '../../../hooks/useScope';

interface HasCptDataResult {
  hasCptData: boolean;
}

/**
 * Hybrid CPT-analytics gate: the CPT filter, match-mode widget and by-primary-CPT
 * breakdown render only when BOTH the per-hospital operator flag
 * (`modules.cptAnalytics`) AND the computed data-presence flag (`hasCptData`) are true.
 * See view-api CPT_CODE_CAPTURE_AND_GROUPING.md ("Gating: hybrid").
 *
 * `scope` is typed `any` in the analytics pages, so the module read is unchecked by design.
 */
export const useCptEnabled = (): boolean => {
  const scope = useScope();
  const cptModuleEnabled: boolean = Boolean(scope?.hospital?.modules?.cptAnalytics);

  const { data } = useQuery<HasCptDataResult>(hasCptDataQuery);
  const hasCptData = Boolean(data?.hasCptData);

  return cptModuleEnabled && hasCptData;
};
